import { noop } from "lodash";
import { useEffect, useRef } from "react";
/**
 * Taken from https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 * A declarative hook to set an interval.
 */
export function useInterval(callback: () => void, delay: number | null) {
  const savedCallback = useRef<typeof callback>(noop);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}
